import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import {
  useUpdateUserMutation,
  useWhoamiQuery,
} from "../../Redux/Services/userApi";
import { Button, Col, Modal, Row } from "react-bootstrap";
import moment from "moment-timezone";
import { auth0Config } from "../../Config/auth0Conifg";
import { tosVersion } from "./tos.constant";
import { disclaimerMembership } from "./Disclaimer";

export default function TosCheck() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState<string | null>(null);
  // console.log({ isAuthenticated, token });
  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently({
        authorizationParams: {
          audience: auth0Config.audience,
        },
      })
        .then((accessToken) => {
          setToken(accessToken);
        })
        .catch((error) => {
          console.error("Error getting access token:", error);
        });
    }
  }, [isAuthenticated]);
  if (token !== null) return <UserAgreementModal token={token} />;

  return null;
}

function UserAgreementModal({ token }: { token: string }) {
  const { data: user, isLoading, isFetching } = useWhoamiQuery({ token });
  const [clicked, setClicked] = useState(false);
  const [extraInfo, setExtraInfo] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
  });
  useEffect(() => {
    if (user) {
      setExtraInfo({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        companyName: user.companyName || "",
      });
    }
  }, [user]);
  const [updateUser] = useUpdateUserMutation();
  // console.log({ user });
  if (isLoading || isFetching) return null;
  if (
    user &&
    (!user.tos.accepted ||
      user.firstName === "" ||
      user.lastName === "" ||
      user.companyName === "")
  ) {
    return (
      <Modal show={true} size="lg" className="tos-check">
        <Modal.Header>
          <Modal.Title as="h1">
            {user.tos.accepted ? "User Profile" : "Membership Disclaimer"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {user.tos.accepted && (
            <p>
              We like to know more about you. Please complete the following user
              profile:
            </p>
          )}
          <Row>
            <Col>
              <label>First Name</label>
              <input
                value={extraInfo.firstName}
                onChange={(e) =>
                  setExtraInfo({ ...extraInfo, firstName: e.target.value })
                }
              />
            </Col>
            <Col>
              <label>Last Name</label>
              <input
                value={extraInfo.lastName}
                onChange={(e) =>
                  setExtraInfo({ ...extraInfo, lastName: e.target.value })
                }
              />
            </Col>
          </Row>
          <label>Company Name</label>
          <input
            value={extraInfo.companyName}
            onChange={(e) =>
              setExtraInfo({ ...extraInfo, companyName: e.target.value })
            }
          />
          {!user.tos.accepted && (
            <>
              {disclaimerMembership}
              <p>By clicking Accept, you acknowledge and accept these terms.</p>
            </>
          )}
          <div>
            <Button
              onClick={() => {
                setClicked(true);
                updateUser({
                  data: {
                    firstName: extraInfo.firstName,
                    lastName: extraInfo.lastName,
                    companyName: extraInfo.companyName,
                    tos: {
                      accepted: true,
                      version: tosVersion,
                      acceptedOn:
                        user.tos.acceptedOn !== 0
                          ? user.tos.acceptedOn
                          : moment().unix(),
                    },
                  },
                  token,
                });
              }}
              disabled={
                clicked ||
                extraInfo.firstName === "" ||
                extraInfo.lastName === "" ||
                extraInfo.companyName === ""
              }
            >
              {clicked
                ? "Please wait..."
                : user.tos.accepted
                  ? "Update"
                  : "Accept"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  return null;
}
